import { formatStatusDisplay } from "pages/crawler/utils/crawlerStatusUtils";

/**
 * Update a specific job's status in a jobs array
 */
export const updateJobStatus = (jobs: any[], jobId: string, newStatus: any): any[] => {
  return jobs.map(job =>
    job.id === jobId
      ? { ...job, status: formatStatusDisplay(newStatus) }
      : job
  );
};